import React from 'react';
import { Layout, Typography, Divider, Space, Grid } from 'antd';
import { 
  FacebookOutlined,
  GlobalOutlined,
  TikTokOutlined,
  SafetyCertificateOutlined 
} from '@ant-design/icons';

const { Footer } = Layout;
const { Text, Link } = Typography;
const { useBreakpoint } = Grid;

const AppFooter = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  return (
    <Footer style={{
      background: 'linear-gradient(to right, #2a2b2b, #353435)',
      padding: isMobile ? '16px 24px' : '24px 50px',
      color: '#fff',
      borderTop: '1px solid #f49b33'
    }}>

      <div style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        alignItems: isMobile ? 'flex-start' : 'center',
        maxWidth: '1200px',
        margin: '0 auto',
        gap: isMobile ? '16px' : 0
      }}>
        <div style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'flex-start' : 'center',
          gap: isMobile ? '8px' : 0
        }}>
          <Space size="middle">
            <SafetyCertificateOutlined style={{ 
              color: '#f49b33', 
              fontSize: isMobile ? '18px' : '20px' 
            }} />
            <Text strong style={{ color: '#fff', whiteSpace: 'nowrap' }}>
              LION BUILDINGS MONITORING SYSTEM
            </Text>
          </Space>
          
          {!isMobile && (
            <Divider type="vertical" style={{ 
              backgroundColor: '#555', 
              margin: '0 20px',
              height: '20px'
            }} />
          )}
          
          <Text style={{ color: '#aaa', whiteSpace: 'nowrap' }}>
            © 2025 All Rights Reserved
          </Text>
        </div>
        
        <Space size={isMobile ? 'middle' : 'large'}>
          <Link 
            href="https://www.facebook.com/LionBuildings" 
            target="_blank"
            style={{ color: '#fff' }}
          >
            <FacebookOutlined style={{ fontSize: isMobile ? '18px' : '20px' }} />
          </Link>
          <Link 
            href="https://lionbuildings.com/" 
            target="_blank"
            style={{ color: '#fff' }}
          >
            <GlobalOutlined style={{ fontSize: isMobile ? '18px' : '20px' }} />
          </Link>
          <Link 
            href="https://www.tiktok.com/@lionbuildings" 
            target="_blank"
            style={{ color: '#fff' }}
          >
            <TikTokOutlined style={{ fontSize: isMobile ? '18px' : '20px' }} />
          </Link>
        </Space>
      </div>
      
      <Divider style={{ 
        backgroundColor: '#444', 
        margin: isMobile ? '12px 0' : '16px 0' 
      }} />
      
      <div style={{ 
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: isMobile ? 'flex-start' : 'center',
        gap: isMobile ? '12px' : '24px'
      }}>
        <Link href="#" style={{ color: '#aaa', whiteSpace: 'nowrap' }}>
          Privacy Policy
        </Link>
        <Link href="#" style={{ color: '#aaa', whiteSpace: 'nowrap' }}>
          Terms of Service
        </Link>
        <Link href="#" style={{ color: '#aaa', whiteSpace: 'nowrap' }}>
          Contact Us
        </Link>
        <Link href="#" style={{ color: '#aaa', whiteSpace: 'nowrap' }}>
          Documentation
        </Link>
      </div>
    </Footer>
  );
};

export default AppFooter;